import { useEffect, useState } from 'react';

import { AccountSlideAbout } from '@playbooks/components/account/account-slide-about';
import { AccountSlideAppearance } from '@playbooks/components/account/account-slide-appearance';
import { AccountSlideBtn } from '@playbooks/components/account/account-slide-btn';
import { AccountSlideCommunity } from '@playbooks/components/account/account-slide-community';
import { AccountSlideDevelopers } from '@playbooks/components/account/account-slide-developers';
import { AccountSlideResources } from '@playbooks/components/account/account-slide-resources';
import { AccountSlideSelect } from '@playbooks/components/account/account-slide-select';
import { AccountSlideSupport } from '@playbooks/components/account/account-slide-support';
import { GuestSlideAbout } from '@playbooks/components/guest/guest-slide-about';
import { useSession, useWorkspace } from '@playbooks/contexts';
import { Button } from '@playbooks/ui/components/button';
import { Icon } from '@playbooks/ui/components/icon';
import { Sheet, SheetContent, SheetTrigger } from '@playbooks/ui/components/sheet';

const WorkspaceMenuSlide = ({ target }) => {
	const [open, setOpen] = useState(false);
	const [view, setView] = useState('about');
	const workspace = useWorkspace();
	const session = useSession();

	// Computed
	const profileHref = workspace.workspace.appPath || workspace.rootLink || '/';

	// Hooks
	useEffect(() => {
		if (open) setView('about');
	}, [open]);

	// Methods
	const onClose = () => setOpen(false);
	const onView = view => setView(view);

	const onLogout = () => {
		onClose();
		session.onLogout();
	};

	const onSelect = (type, nextAccount) => {
		workspace.onSwitch(type, nextAccount);
		onClose();
	};

	// Props
	const props = {
		account: workspace.workspace,
		accountType: workspace.type,
		workspace,
		profileHref,
		session,
		target,
		onLogout,
		onSelect,
		onView,
	};

	// Render
	return (
		<Sheet open={open} onOpenChange={setOpen}>
			<SheetTrigger
				render={
					workspace.workspace.id ? (
						<AccountSlideBtn account={workspace.workspace} accountType={workspace.type} open={open} />
					) : (
						<Button variant='outline' size='icon' aria-label='menu'>
							<Icon data-icon='inline-start' type='far' icon='circle-user' aria-hidden />
						</Button>
					)
				}
			/>
			<SheetContent side='right' showCloseButton={false} className='gap-0 p-0'>
				{workspace.workspace.id ? (
					<>
						{view === 'about' && <AccountSlideAbout {...props} />}
						{view === 'select' && <AccountSlideSelect {...props} onPrev={() => setView('about')} />}
						{view === 'appearance' && <AccountSlideAppearance onPrev={() => setView('about')} />}
						{view === 'community' && <AccountSlideCommunity onPrev={() => setView('about')} />}
						{view === 'developers' && <AccountSlideDevelopers target={target} onPrev={() => setView('about')} />}
						{view === 'resources' && <AccountSlideResources target={target} onPrev={() => setView('about')} />}
						{view === 'support' && <AccountSlideSupport target={target} onPrev={() => setView('about')} />}
					</>
				) : (
					<>
						{view === 'about' && <GuestSlideAbout target={target} onView={onView} />}
						{view === 'appearance' && <AccountSlideAppearance onPrev={() => setView('about')} />}
						{view === 'community' && <AccountSlideCommunity onPrev={() => setView('about')} />}
						{view === 'developers' && <AccountSlideDevelopers target={target} onPrev={() => setView('about')} />}
						{view === 'resources' && <AccountSlideResources target={target} onPrev={() => setView('about')} />}
						{view === 'support' && <AccountSlideSupport target={target} onPrev={() => setView('about')} />}
					</>
				)}
			</SheetContent>
		</Sheet>
	);
};

export { WorkspaceMenuSlide };
